import {
  useRef,
  useState,
  useEffect,
  ReactNode,
  useContext,
  createContext,
  useCallback,
} from 'react'
import {
  LocalizedString,
  RootNodeInput,
  StatusPageEventHistoryItemComponentStatus,
} from '../api/types'
import { useTw } from './Styles'
import { StaticRenderer } from './StaticRenderer'
import { ConversationItemFragment } from '../api/Fragments/ConversationItem.generated'

export * from './S3Upload'
export * from './IntersectionObserver'

export const defaultLogo =
  'data:image/svg+xml;base64,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'

export function usePrevious<value>(value: value) {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref = useRef<value>()

  // Store current value in ref
  useEffect(() => {
    ref.current = value
  }, [value]) // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current
}

export function useLogo(sender: { logoURL?: string } | { image?: string }) {
  if ('logoURL' in sender && sender.logoURL) return sender.logoURL
  if ('image' in sender && sender.image) return sender.image

  return defaultLogo
}

type Item = {
  sender: Partial<
    | {
        __typename: 'MemberUser'
        _id: string
        name: string
        title: string
        logoURL: string
      }
    | { __typename: 'Visitor'; _id: string; name: string; image?: string }
    | {
        __typename: 'APIIntegration'
        _id: string
        displayName?: string
        displayDescription?: string
        logoURL: string
      }
  >
}

export function useSenderInfo(item: Item) {
  switch (item.sender.__typename) {
    case 'MemberUser':
      return {
        bot: false,
        _id: item.sender?._id,
        name: item.sender?.name,
        title: item.sender?.title,
        logoURL: item.sender?.logoURL || defaultLogo,
      }

    case 'Visitor':
      return {
        bot: false,
        _id: item.sender?._id,
        name: item.sender?.name,
        logoURL: item.sender?.image || defaultLogo,
      }

    case 'APIIntegration':
      return {
        bot: true,
        _id: item.sender?._id,
        name: item.sender.displayName,
        title: item.sender.displayDescription,
        logoURL: item.sender?.logoURL || defaultLogo,
      }
  }

  return null
}

function makeTextRootNode(text: string) {
  return {
    version: 1,
    type: 'root',
    indent: 0,
    format: '',
    direction: 'ltr',
    children: [
      {
        version: 1,
        type: 'paragraph',
        indent: 0,
        format: '',
        direction: 'ltr',
        children: [
          {
            version: 1,
            detail: 0,
            format: '0',
            style: '',
            type: 'text',
            mode: 'normal',
            text: text,
          },
        ],
      },
    ],
  }
}

export function MessagePreview({
  message,
}: {
  message: ConversationItemFragment
}) {
  const tw = useTw()
  if (message?.content?.message !== null)
    return (
      <StaticRenderer
        theme={{ paragraph: tw`truncate` }}
        content={message.content.message as RootNodeInput}
      />
    )

  if (message?.card?.description)
    return (
      <StaticRenderer
        theme={{ paragraph: tw`truncate` }}
        content={makeTextRootNode(message?.card?.description)}
      />
    )

  if (message?.card?.title)
    return (
      <StaticRenderer
        theme={{ paragraph: tw`truncate` }}
        content={makeTextRootNode(message?.card?.title)}
      />
    )

  if (message?.card?.appTitle)
    return (
      <StaticRenderer
        theme={{ paragraph: tw`truncate` }}
        content={makeTextRootNode(message?.card?.appTitle)}
      />
    )

  if (message?.buttons[0]?.text)
    return (
      <StaticRenderer
        theme={{ paragraph: tw`truncate` }}
        content={makeTextRootNode(message?.buttons[0]?.text)}
      />
    )

  return null
}

export function getHighestStatus(
  statuses: StatusPageEventHistoryItemComponentStatus[]
) {
  if (statuses.includes(StatusPageEventHistoryItemComponentStatus.MajorOutage))
    return StatusPageEventHistoryItemComponentStatus.MajorOutage

  if (
    statuses.includes(StatusPageEventHistoryItemComponentStatus.PartialOutage)
  )
    return StatusPageEventHistoryItemComponentStatus.PartialOutage

  if (statuses.includes(StatusPageEventHistoryItemComponentStatus.Degraded))
    return StatusPageEventHistoryItemComponentStatus.Degraded

  return StatusPageEventHistoryItemComponentStatus.Operational
}

export function isDark(color: string) {
  const c = color.substring(1) // strip #
  const rgb = parseInt(c, 16) // convert rrggbb to decimal
  const r = (rgb >> 16) & 0xff // extract red
  const g = (rgb >> 8) & 0xff // extract green
  const b = (rgb >> 0) & 0xff
  const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b

  return luma < 130
}

export function shortenString(str: string, length = 15) {
  return str.length > length
    ? str.substr(0, length - 11) +
        '...' +
        str.substr(str.length - 7, str.length)
    : str
}

export function formatBytes(bytes: number, decimals = 2) {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

/**
 * Returns the proper localization of the string
 * @param text - Localized string array
 * @returns Text for your current locale.
 */
export function localizeString(text: LocalizedString[]) {
  const texts = new Map<string, string>()
  text.forEach((_) => texts.set(_.language, _.value))

  // Returns an exact match
  if (texts.has(navigator.language)) return texts.get(navigator.language)

  // Returns a partial match
  if (
    navigator.language.split('-')[0] &&
    texts.has(navigator.language.split('-')[0])
  )
    return texts.get(navigator.language.split('-')[0])

  return texts.has('en') ? texts.get('en') : null
}

/**
 * Returns the proper localization of the string
 * @param text - Localized string array
 * @returns Text for your current locale.
 */
export function localizeContent<T>(text: { language: string; value: T }[]) {
  const texts = new Map<string, T>()
  text.forEach((_) => texts.set(_.language, _.value))

  // Returns an exact match
  if (texts.has(navigator.language)) return texts.get(navigator.language)

  // Returns a partial match
  if (
    navigator.language.split('-')[0] &&
    texts.has(navigator.language.split('-')[0])
  )
    return texts.get(navigator.language.split('-')[0])

  return texts.has('en') ? texts.get('en') : null
}

type WidgetOpenManagerProps = {
  children: ReactNode
  responsive: boolean | 'hide'
  responsiveBreakpoint: number
  openCallback: (open: boolean) => void
}

const OpenContext = createContext<{
  open: boolean
  responsive: boolean | 'hide'
  responsiveBreakpoint: number
  isMobile: boolean
  setOpen: (open: boolean) => void
}>(null)

const RootContext = createContext<HTMLDivElement | ShadowRoot>(null)

export function WidgetRootManager({
  root,
  children,
}: {
  root: HTMLDivElement | ShadowRoot
  children: ReactNode
}) {
  return <RootContext.Provider value={root}>{children}</RootContext.Provider>
}

export function WidgetOpenManager({
  children,
  responsive,
  responsiveBreakpoint,
  openCallback,
}: WidgetOpenManagerProps) {
  const [open, _setOpen] = useState(false)
  const [isMobile, _setIsMobile] = useState(false)

  const resizeListener = useCallback(() => {
    const newValue = !!window.matchMedia(
      `(max-width: ${responsiveBreakpoint}px)`
    ).matches

    if (newValue != isMobile) {
      _setIsMobile(newValue)
    }
  }, [isMobile, responsiveBreakpoint])

  useEffect(() => {
    resizeListener()
    window.addEventListener('resize', resizeListener)
    return () => {
      window.removeEventListener('resize', resizeListener)
    }
  }, [resizeListener])

  return (
    <OpenContext.Provider
      value={{
        open,
        responsive,
        responsiveBreakpoint,
        isMobile,
        setOpen(newOpen: boolean) {
          openCallback(newOpen)
          _setOpen(newOpen)
        },
      }}
    >
      {children}
    </OpenContext.Provider>
  )
}

export function useRoot() {
  return useContext(RootContext)
}

export function useWidgetOpen() {
  return useContext(OpenContext)
}
